module.exports = __webpack_public_path__ + "static/media/shell-custom.b2af975c.png";